import { addDays, differenceInCalendarDays, isSameDay } from 'date-fns'

export type DateRangeSelection = { start: Date; end: Date | null }

export type DateRangeClickState = {
  start: Date | null
  end: Date | null
  anchor: Date | null
}

function isAwaitingEnd(start: Date, end: Date | null, anchor: Date | null): boolean {
  if (end === null) return true
  return anchor !== null && isSameDay(anchor, start)
}

export function resolveDateRangeClick(
  { start, end, anchor }: DateRangeClickState,
  clicked: Date,
  maxRangeDays?: number,
): DateRangeSelection {
  if (start === null) return { start: clicked, end: null }
  if (!isAwaitingEnd(start, end, anchor)) return { start: clicked, end: null }
  if (differenceInCalendarDays(clicked, start) < 0) return { start: clicked, end: null }
  if (maxRangeDays !== undefined && differenceInCalendarDays(clicked, start) + 1 > maxRangeDays) {
    return { start, end: addDays(start, maxRangeDays - 1) }
  }
  return { start, end: clicked }
}
